/**
 * Отдаёт Blob браузеру: открывает в новой вкладке (preview) или скачивает файлом.
 */
export const openBlob = (blob: Blob, filename?: string): void => {
  const url = window.URL.createObjectURL(blob)
  if (filename) {
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } else {
    window.open(url, '_blank')
  }
  // Освобождаем URL с запасом, чтобы вкладка успела загрузиться.
  setTimeout(() => window.URL.revokeObjectURL(url), 60000)
}

export default openBlob
